import React from 'react';

import { Button } from '@mui/material';
import { authService } from 'iron-forge-react-modules';
import { activityTemplates } from 'modules';



export const AccessDeniedActivity: React.FC = () => {

  function handleClickLogOut() {
    authService.logOut();
  }



  return (
    <activityTemplates.BaseActivityTemplate.FC>
      <div>Your account is pending approval. You do not have access to this application at this time.</div>

      <Button onClick={handleClickLogOut}>
        Log Out
      </Button>
    </activityTemplates.BaseActivityTemplate.FC>
  );
};
